import { render, staticRenderFns } from "./ItemServico.vue?vue&type=template&id=3a2ab149&scoped=true&"
import script from "./ItemServico.vue?vue&type=script&lang=js&"
export * from "./ItemServico.vue?vue&type=script&lang=js&"
import style0 from "./ItemServico.vue?vue&type=style&index=0&id=3a2ab149&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2ab149",
  null
  
)

export default component.exports